import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { Observable } from 'rxjs';
import { ApiResponse } from '@card-software/library';
import { FinishingRoute } from '../../models/production/finishing-route';

@Injectable({
  providedIn: 'root',
})
export class FinishingRouteProxyService {
  private readonly httpClient = inject(HttpClient);
  private baseUrl = `${environment.proxyUrls.productionApi}/api/v1/finishing-route`;

  public getByProductionCardId(productionCardId: string): Observable<ApiResponse<FinishingRoute[]>> {
    return this.httpClient.get<ApiResponse<FinishingRoute[]>>(`${this.baseUrl}/production-card/${productionCardId}`);
  }
}
